var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2953 3.79615C23.9157 0.986998 22.4732 0.531461 19.664 0.227769C18.4493 0.151846 17.1586 0.075923 15.8679 0C14.5772 0 13.3624 0 12.2995 0C10.1737 0 7.36453 0.0759229 4.93499 0.303692C2.12584 0.531461 0.607384 0.986998 0.227769 3.79615C0.151846 4.47945 0.075923 5.23868 0.075923 6.07384C0 6.90899 0 7.82006 0 8.73114C0 10.5533 0.075923 12.3754 0.227769 13.5902C0.607384 16.4753 2.04992 16.8549 4.93499 17.1586C6.14976 17.3104 7.44045 17.3104 8.73114 17.3864C10.0218 17.4623 11.2366 17.4623 12.2995 17.4623C14.4254 17.4623 17.2345 17.3864 19.664 17.1586C22.4732 16.9308 23.9157 16.4753 24.2953 13.5902C24.3713 12.9828 24.4472 12.2236 24.5231 11.3884C24.599 10.5533 24.599 9.64221 24.599 8.73114C24.5231 6.90899 24.4472 5.08684 24.2953 3.79615ZM9.79406 12.4514V5.01091L16.1716 8.65522L9.79406 12.4514Z",
    fill: "#F39422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.3e44a2b348ab5687555b2cb56bbbbaf3.svg";
export { ForwardRef as ReactComponent };